export const TERMS_AND_CONDITIONS =
  "https://drive.google.com/file/d/1z7R48-Bd_KQvfLfyFxrJaD-jHE47Pn1P/view";
export const PRIVACY_POLICY =
  "https://drive.google.com/file/d/1SPQp1tAIjKR7BnK6BhscZF9et-ddSVDP/view";

export const LINKS = {
  termsAndConditions: TERMS_AND_CONDITIONS,
  privacyPolicy: PRIVACY_POLICY,
};
